import { Skeleton } from "antd";
import { FormattedMessage } from "react-intl";
import "./ManagePageTitle.scss";

type Props = {
  entityType: string;
  entityName?: string;
  isLoading: boolean;
};

export const ManagePageTitle = ({ entityType, entityName, isLoading }: Props) => {
  if (isLoading) {
    return <Skeleton.Input active className="manage-page-title-skeleton" />;
  }

  if (entityName) {
    return <FormattedMessage id="managePage.edit.title" values={{ name: entityName }} />;
  }

  return <FormattedMessage id={`managePage.add.${entityType}.title`} />;
};
